import { Directive, Input, ElementRef, OnInit } from '@angular/core';
import { Initial } from './id-initial';

@Directive({
  selector: '[appDisplayID]'
})
export class DisplayIdDirective implements OnInit {

  @Input() id: any;
  @Input() name: any;

  constructor(private el: ElementRef) { }

  getDisplayId() {
    if (this.id) {
      for (let k in Initial) {
        let v = Initial[k];
        if (k === this.name) {
          return v + '-' + this.id;
        }
      }
    }
  }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    nativeElement.innerText = this.getDisplayId();
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/displayid/displayid.directive.ts